import { createSlice } from '@reduxjs/toolkit';

import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { useCallback } from 'react';

export const useCreateEditShiftLoading = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.loadingCreateEditShift);

  const setLoading = useCallback(
    (isLoading: boolean) => {
      dispatch(loadingCreateEditShiftSlice.actions.setLoading(isLoading));
    },
    [dispatch],
  );

  return { loading, setLoading };
};

const loadingCreateEditShiftSlice = createSlice({
  name: 'loadingCreateEditShift',
  initialState: false,
  reducers: {
    setLoading: (_, action) => action.payload,
  },
});

const { reducer } = loadingCreateEditShiftSlice;
export { reducer as loadingCreateEditShiftReducer };
